import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=a08d7c14&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a08d7c14')) {
      api.createRecord('a08d7c14', component.options)
    } else {
      api.reload('a08d7c14', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=a08d7c14&", function () {
      api.rerender('a08d7c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I3yPMKth5714/JS/imageCarousel.vue"
export default component.exports